module.exports = __webpack_public_path__ + "static/heroes-56d2c73c30b77eed1f08a93c78aa2d43.png";